import styled from 'styled-components';

import buttonStyles from './buttonStyles';

const StyledButton = styled.button`${buttonStyles}`;

export default StyledButton;



// WEBPACK FOOTER //
// ./app/components/Button/StyledButton.js